// extracted by mini-css-extract-plugin
export default {"dotRepeat":"WbsOption_dotRepeat__Pka1r"};